{
  "columns": [],
  "buttons": [
    {
      "button_id": "Approve",
      "button_label": "Approve",
      "buttonAction": "approveMassAdjustment",
      "className": "primary"
    },
    {
      "button_id": "Reject",
      "button_label": "Reject",
      "buttonAction": "rejectMassAdjustment",
      "className": "primary-btn-color"
    }
  ],
  "apiDetails": "mass-adjustment-list.json",
  "pageName": "massAdjustmentList",
  "orderByColumn": ["modifiedDate"],
  "orderBy": ["desc"]
}
